var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6.76329C6.0375 6.76329 5.25 6.44767 4.6375 5.81643C4.025 5.18519 3.71875 4.37359 3.71875 3.38164C3.71875 2.38969 4.025 1.5781 4.6375 0.94686C5.25 0.31562 6.0375 0 7 0C7.9625 0 8.75 0.31562 9.3625 0.94686C9.975 1.5781 10.2812 2.38969 10.2812 3.38164C10.2812 4.37359 9.975 5.18519 9.3625 5.81643C8.75 6.44767 7.9625 6.76329 7 6.76329ZM0 14V11.8808C0 11.3097 0.138542 10.8213 0.415625 10.4155C0.692708 10.0097 1.05 9.70156 1.4875 9.49114C2.46458 9.04026 3.40156 8.70209 4.29844 8.47665C5.19531 8.25121 6.09583 8.13849 7 8.13849C7.90417 8.13849 8.80104 8.25497 9.69063 8.48792C10.5802 8.72088 11.5135 9.05529 12.4906 9.49114C12.9427 9.70156 13.3073 10.0097 13.5844 10.4155C13.8615 10.8213 14 11.3097 14 11.8808V14H0Z",
    fill: "#DCE0E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserRanking);
export default __webpack_public_path__ + "static/media/iconUserRanking.2f33b027bab20abbd7125f671b72d642.svg";
export { ForwardRef as ReactComponent };